import { useEffect, useState } from 'react';
import { getStaffProfile } from './data/api';
import { clearDemoRole, demoRoleFor, readDemoRole, saveDemoRole } from './demoAccounts';

// Vaqtinchalik demo (qarang: demoAccounts.js). Backend haqiqiy rollarni qaytara boshlaganda o'chiriladi.
//
// Backend roli "admin" bo'lsa, profil telefoni bo'yicha kabinet roli aniqlanadi (Login.jsx o'zgarmaydi).
// - Login'dan keyin (sahifa yangilanmasdan) tekshiruv tugaguncha pending=true: admin sahifalari ochilmaydi.
// - Sahifa yangilanganda saqlangan rol darhol ishlatiladi, profil fonda qayta tekshiriladi.
// - Tizimdan chiqilgan (token yo'q) yoki rol "admin" bo'lmasa — demo rol o'chiriladi.
// - Profilni olib bo'lmasa, holat o'zgarmaydi.
export function useDemoRole(token, role) {
  const [initialToken] = useState(token);
  const [demoRole, setDemoRole] = useState(() => (token ? readDemoRole(role) : null));
  const [checkedToken, setCheckedToken] = useState(null);

  useEffect(() => {
    if (!token || role !== 'admin') {
      clearDemoRole();
      setDemoRole(null);
      return undefined;
    }

    let cancelled = false;
    getStaffProfile()
      .then((profile) => {
        if (cancelled) return;
        const code = demoRoleFor(role, profile?.phone_number);
        if (code) saveDemoRole(code);
        else clearDemoRole();
        setDemoRole(code);
      })
      .catch(() => {})
      .finally(() => {
        if (!cancelled) setCheckedToken(token);
      });

    return () => {
      cancelled = true;
    };
  }, [token, role]);

  const pending = Boolean(token) && role === 'admin' && token !== initialToken && checkedToken !== token;
  return { demoRole: role === 'admin' ? demoRole : null, pending };
}
